"use client";

import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { PILIERS, IMG, type Pilier } from "@/lib/diwline-data";
import { Cpu, Coins, Landmark, Award } from "lucide-react";

const ICONES: Record<Pilier["icone"], typeof Cpu> = {
  cpu: Cpu,
  coins: Coins,
  landmark: Landmark,
  award: Award,
};

export function ConnexionDigitale() {
  return (
    <section id="digital" className="relative bg-royal py-24 md:py-32" aria-label="Connexion Digitale Royale">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="VI"
          titre="Connexion Digitale Royale"
          intro="À la limite de l'ingéniosité et de la technologie : la Maison DIW'LINE déploie ses piliers digitaux pour un sursaut national de l'or liquide."
        />

        <div className="grid items-stretch gap-10 lg:grid-cols-5 lg:gap-12">
          <Reveal className="lg:col-span-2">
            <div className="gold-frame relative h-full min-h-[320px] overflow-hidden">
              <img
                src={`${IMG}/digital-royal.jpg`}
                alt="L'Ingénieure du Sursaut — innovation digitale royale"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-royal via-transparent to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="font-elegant text-lg italic text-gold-light">
                  « L&apos;avenir de l&apos;or liquide s&apos;écrit en numérique. »
                </p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-3 grid gap-5 sm:grid-cols-2">
            {PILIERS.map((p, i) => {
              const Icone = ICONES[p.icone];
              return (
                <Reveal key={p.titre} delay={i * 0.09} className="h-full">
                  <div className="group relative h-full overflow-hidden rounded-sm border border-gold/20 bg-royal-brown/80 p-6 transition-all duration-500 hover:border-gold/55 hover:bg-royal-panel">
                    <span className="absolute -right-5 -top-5 font-display text-7xl text-gold/8 transition-colors group-hover:text-gold/15" aria-hidden>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-sm border border-gold/40 bg-royal">
                      <Icone className="h-6 w-6 text-gold" aria-hidden />
                    </span>
                    <h3 className="mt-4 font-display text-lg font-semibold text-gold-light">{p.titre}</h3>
                    <p className="mt-2.5 text-[13px] leading-relaxed text-cream/72">{p.texte}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
